import apiClient from './apiClient';

export const leaksService = {
  // Get all available tests
  getAvailableTests: () => apiClient.get('/leaks/available'),

  // Get specific test details
  getTest: (testId) => apiClient.get(`/leaks/${testId}`),

  // Start a test session
  startTest: (testId) => apiClient.post(`/leaks/${testId}/start`),

  // Get current module for session
  getCurrentModule: (sessionId) => apiClient.get(`/leaks/session/${sessionId}/module`),

  // Submit an answer
  submitAnswer: (sessionId, data) => 
    apiClient.post(`/leaks/session/${sessionId}/answer`, data),

  // Complete current module
  completeModule: (sessionId, data) => 
    apiClient.post(`/leaks/session/${sessionId}/complete-module`, data),

  // Complete entire test
  completeTest: (sessionId) => 
    apiClient.post(`/leaks/session/${sessionId}/complete`),

  // Get results for a session
  getResults: (sessionId) => 
    apiClient.get(`/leaks/session/${sessionId}/results`),

  // Get leaderboard for a test
  getLeaderboard: (testId, timeFilter = null) => 
    apiClient.get(`/leaks/${testId}/leaderboard`, { params: { timeFilter } }),

  // Get personal statistics
  getMyStats: () => apiClient.get('/leaks/mystats'),

  // Generate AI feedback
  generateFeedback: (sessionId) => 
    apiClient.post(`/leaks/session/${sessionId}/generate-feedback`)
};

export default leaksService;
